// Module
var code = "<textarea id=\"inline-editor\" class=\"inline-editor\" draggable=\"false\" autofocus=\"autofocus\" >";
// Exports
export default code;